const {
  TRUMP_NO_TRUMP,
  TRUMP_ALL_TRUMP,
  isStrictlyStrongerBid,
  MIN_OPENING_TENS,
} = require("../armenian/auction");

/**
 * @typedef {{ phase: 'bidding'|'closed', turnSeat: 0|1, highestBid: object|null, bidAuthorSeat: 0|1|null, passesWithoutBid: number, passesAfterBid: number }} Auction2pState
 */

/**
 * @param {0|1} dealerSeat
 * @returns {Auction2pState}
 */
function createInitialAuction2p(dealerSeat) {
  const d = dealerSeat === 1 ? 1 : 0;
  const firstSpeaker = (d + 1) % 2;
  return {
    phase: "bidding",
    turnSeat: /** @type {0|1} */ (firstSpeaker),
    highestBid: null,
    bidAuthorSeat: null,
    passesWithoutBid: 0,
    passesAfterBid: 0,
  };
}

/**
 * @param {Auction2pState} a
 * @param {{ type: 'PASS'|'BID', seat: 0|1, bid?: { tens: number, trump: unknown, kapot?: boolean } }} cmd
 * @param {0|1} dealerSeat — при полном пасе до заявки: новая раздача, тот же дилер.
 * @returns {{ state: Auction2pState, redealt?: boolean, closed?: boolean }}
 */
function applyAuction2pCommand(a, cmd, dealerSeat) {
  const next = {
    phase: /** @type {'bidding'|'closed'} */ (a.phase),
    turnSeat: /** @type {0|1} */ (a.turnSeat),
    highestBid: a.highestBid,
    bidAuthorSeat: a.bidAuthorSeat,
    passesWithoutBid: a.passesWithoutBid,
    passesAfterBid: a.passesAfterBid,
  };

  if (cmd.type === "PASS") {
    if (!next.highestBid) {
      next.passesWithoutBid += 1;
      if (next.passesWithoutBid >= 2) {
        return { state: createInitialAuction2p(dealerSeat), redealt: true };
      }
    } else {
      next.passesAfterBid += 1;
      if (next.passesAfterBid >= 1) {
        next.phase = "closed";
        return { state: next, closed: true };
      }
    }
    next.turnSeat = /** @type {0|1} */ ((cmd.seat + 1) % 2);
    return { state: next };
  }

  if (cmd.type === "BID") {
    const bid = cmd.bid;
    if (!bid || typeof bid !== "object") {
      throw new Error("auction2p: BID requires bid");
    }
    const tens = Number(bid.tens);
    if (next.highestBid == null && (!Number.isFinite(tens) || tens < MIN_OPENING_TENS)) {
      throw new Error(`auction2p: opening bid needs tens >= ${MIN_OPENING_TENS}`);
    }
    if (next.highestBid == null) {
      next.highestBid = bid;
      next.bidAuthorSeat = /** @type {0|1} */ (cmd.seat);
      next.passesWithoutBid = 0;
      next.passesAfterBid = 0;
    } else {
      if (!isStrictlyStrongerBid(bid, next.highestBid)) {
        throw new Error("auction2p: bid must be strictly stronger");
      }
      next.highestBid = bid;
      next.bidAuthorSeat = /** @type {0|1} */ (cmd.seat);
      next.passesAfterBid = 0;
    }
    next.turnSeat = /** @type {0|1} */ ((cmd.seat + 1) % 2);
    return { state: next };
  }

  throw new Error(`auction2p: unknown command ${cmd.type}`);
}

module.exports = {
  createInitialAuction2p,
  applyAuction2pCommand,
  TRUMP_NO_TRUMP,
  TRUMP_ALL_TRUMP,
};
